<template>
  <div id="map"></div>
</template>

<script>
import { Scene, PointLayer, Popup, LineLayer } from '@antv/l7';
import { GaodeMap } from '@antv/l7-maps';
export default {
  name: 'route',
  props: ['ssid'],
  mounted() {
    this.initScene();
  },
  methods: {
    initScene() {
      const scene = new Scene({
              id: "map",
              map: new GaodeMap({
                // style: "dark", // 样式URL
                center: [120.19382669582967, 30.258134],
                pitch: 0,
                zoom: 4,
                token: "009cebdd6eed59aa0e6c64f21b6038ac"
                }),
              logoVisible: false
      });
      this.initLayer(scene, this);
    },
    initLayer(scene, that) {
      Promise.all([
        fetch('https://remoteserver.storkhealthcare.cn/probe/getLocationBySSID?SSID=' + this.ssid).then(d => d.text()),
        fetch('https://remoteserver.storkhealthcare.cn/probe/getRouteBySSID?SSID=' + this.ssid).then(d => d.text())
      ]).then(function onLoad([ dot, flyline ]) {
          const dotData = eval(dot);
          const flydata = eval(flyline).map(item => {
            const latlng1 = item.from.split(',').map(e => { return e * 1; });
            const latlng2 = item.to.split(',').map(e => { return e * 1; });
            return { coord: [ latlng1, latlng2 ] };
        });
        const dotPoint = new PointLayer()
          .source(dotData, {
            parser: {
              type: 'json',
              x: 'longitude',
              y: 'latitude'
            }
          })
          .shape('circle')
          .color('#5C6BC0')
          .animate(true)
          .size(40)
          .style({
            opacity: 1.0
          });
        const flyLine = new LineLayer()
          .source(flydata, {
            parser: {
              type: 'json',
              coordinates: 'coord'
            }
          })
          .color('#ff6b34')
          .shape('arc3d')
          .size(2)
          .active(true)
          .animate({
            interval: 2,
            trailLength: 2,
            duration: 1
          })
          .style({
            opacity: 1
          });

        dotPoint.on('mousemove', e => {
          let startime = that.set_time(e.feature.begin_time);
          let endtime = that.set_time(e.feature.end_time);
          let usetime = ((parseInt(e.feature.end_time) - parseInt(e.feature.begin_time))/1000/60).toFixed(2);
          const popup = new Popup({
          offsets: [ 0, 0 ],
          closeButton: false
          })
          .setLnglat(e.lngLat)
          .setHTML(
            `<ul style = {
              {
                margin: 0,
              }
            }>
              <li>开始时间：${startime}</li>
              <li>结束时间：${endtime}</li>
              <li>使用时长：${usetime} 分钟</li>
            </ul>`
            );
          scene.addPopup(popup);
          dotPoint.on("mouseout", e => {
            scene.removePopup(popup)
          })
        });
        scene.addLayer(dotPoint);
        scene.addLayer(flyLine);
      });
    },
    set_time(str){
      var n = parseInt(str);
      var date = new Date(n); //获取一个时间对象

      let Y = date.getFullYear() + '-';  // 获取完整的年份(4位,1970)
      let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1)+ '-';  // 获取月份(0-11,0代表1月,用的时候记得加上1)
      let D = date.getDate() + '  ';  // 获取日(1-31)
      let h = date.getHours() + ':';  // 获取小时数(0-23)
      let m = date.getMinutes() + ':';  // 获取分钟数(0-59)
      let s = date.getSeconds();  // 获取秒数(0-59)
      return Y + M + D + h + m + s;
    }
  }
}
</script>

<style scoped>
  #map {
    position: absolute;
    width: 1650px;
    height: 730px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Route.vue